<template>
  <div class="page">
    <div class="list-view">
      <ud-empty-row />
      <p class="title">业主自行装修承诺书</p>
      <ud-empty-row />
      <p class="info">本人（单位）______________系_________花园____栋____单元____号房业主，现申请对所购物业进行自行装修，本人已详阅深圳市绿景物业管理有限公司《装修管理协议》等各项装修管理制度，并作如下承诺：</p>
      <p class="info">1、严格按照物业公司装修程序办理各项装修手续，严格按照装修申报内容进行装修。</p>
      <p class="info">2、按服务中心规定要求缴纳一切费用，除业户应缴纳的各项费用外，若为住宅装修还代替装修施工队缴纳装修押金1000元，若为商铺装修还代替施工队缴纳装修押金2500元，以及公共设施维护费、垃圾清运费、临时出入证本工费等各项费用。</p>
      <p class="info">3、加强装修期间的消防安全措施，严格按各项装修管理规定督导施工队文明施工，负责施工人员的管理。</p>
      <p class="info">4、如因本人自行装修造成本小区公用设施设备（包括电梯、消防设施、公共走道、天面等）损坏，本人负责修复，确保恢复其原有使用功能。如由物业服务中心负责修复，修复费用全部由本人承担。</p>
      <p class="info">5、因本人自行装修致使其他业主（住户）利益受到损失的，本人负责所有赔偿费用，并承担由此引发的一切后果。</p>
    </div>
  </div>
</template>

<script>
import UdEmptyRow from '@/components/ud-empty-row'

export default {
  components: {
    UdEmptyRow
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding: 24px;
  box-sizing: border-box;
}

.list-view {
  flex: 1;
  @include relative;
}

.title {
  @include text(28px);
  text-align: center;
}

.info {
  margin-bottom: 12px;
  @include text(22px);
  line-height: 1.2;
  @extend .flex-row;
  justify-content: space-between;
}
</style>